import { RetryLink } from 'apollo-link-retry'

export const retryLink = new RetryLink({
  delay: {
    initial: 300,
    max: Infinity,
    jitter: true
  },
  attempts: {
    max: 5,
    retryIf: (error, _operation) => {
      // Ignore legit errors from the server
      if ([400, 403, 404, 422].includes(error.statusCode)) {
        return false
      }

      return !!error
    }
  }
})
